import { Role } from './role';

export class User {
	id: number;
	email: string;
	password: string;
	firstName: string;
	lastName: string;
	avatar: string;
	name:string;
	mobile:string;
	role: Role;
	token?: string;
	isProfileCreated : boolean;
	subjectArea : string;
	expertCategory:string;
	isApplyonline:boolean;
	captcha:any;
    realcaptcha:any;
}

